function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
}, /*#__PURE__*/React.createElement("style", {
  type: "text/css",
  id: "style10"
}, "\n    .fil0 {fill:#1A1A1A}\n    .fil1 {fill:#666666}\n  "), /*#__PURE__*/React.createElement("style", {
  type: "text/css",
  id: "style51"
}, "\n    .fil0 {fill:#1A1A1A}\n    .fil1 {fill:#666666}\n  "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_x0020_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "m 15305.52,24710.75 c 440.63,-517.56 2183.59,-1286.25 3011.64,-1442.5 -284.64,-371.23 -1077.17,-1350.26 -1444.76,-1666.02 -216.49,-2292.14 -1156.49,-7987.48 -1566.88,-10086.1 -410.39,2098.62 -1350.39,7793.96 -1566.87,10086.1 -367.59,315.76 -1160.13,1294.79 -1444.77,1666.02 828.06,156.25 2571.01,924.94 3011.64,1442.5 z m 0,-7813.66 c -280.12,1648.82 -500.62,3347.6 -667.03,5109.88 -296.44,254.64 -574.3,521.95 -819.9,810.48 550.7,152.11 1053.45,340.73 1488.94,557.35 435.49,-216.62 935.61,-397.09 1486.3,-549.19 -245.6,-288.53 -523.46,-555.84 -819.89,-810.48 -166.42,-1762.28 -388.3,-3469.22 -668.42,-5118.04 z",
  id: "path56"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil1",
  d: "m 15305.52,15297.96 c 410.39,2098.62 720.5,4297.14 936.99,6589.28 367.59,315.76 706.57,651.1 991.2,1022.33 -748.36,206.7 -1401.09,467.86 -1928.19,799.06 -527.1,-331.2 -1179.83,-592.36 -1928.19,-799.06 284.64,-371.23 623.61,-706.57 991.2,-1022.33 216.49,-2292.14 526.6,-4490.66 936.99,-6589.28 z m 0,-2665.63 c 410.39,2098.62 1062.11,6839.4 1278.6,9131.54 367.59,315.76 867.33,915.4 1151.97,1286.63 -748.36,206.7 -1903.47,742.84 -2430.57,1074.04 -527.1,-331.2 -1682.21,-867.34 -2430.57,-1074.04 284.64,-371.23 784.38,-970.87 1151.97,-1286.63 216.49,-2292.14 868.21,-7032.92 1278.6,-9131.54 z",
  id: "path58"
}));

function SvgSmallArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    viewBox: "0 0 60.232799 131.9462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.53511,62.43453)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.01,0,0,0.01,9.5963114,-177.59583)",
    id: "g72",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }, _ref3)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrow);
export default __webpack_public_path__ + "static/media/smallArrow.1837273b.svg";
export { ForwardRef as ReactComponent };